import React, { useEffect, useState, useLayoutEffect } from "react";
import Shopping from "../../../../Diathrive/src/containers/Shopping";
import ViewProduct from "../../../../Diathrive/src/containers/ViewProduct";
import RightPannel from "../../components/RightPannel";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import MyCart from "../../../../Diathrive/src/containers/MyCart";

const ShoppingStore = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [productBeingViewed, setProductBeingViewed] = useState({});
  const [cartBeingViewed, setCartBeingViewed] = useState(
    location?.state?.openCart
  );

  const { setHeaderName } = useOutletContext();

  useLayoutEffect(() => {
    if (setHeaderName) setHeaderName("Store");
  }, [setHeaderName]);

  useEffect(() => {
    setCartBeingViewed(location?.state?.openCart);
  }, [location.key]); //need this so that cart renders when clicking on cart from the store page

  const setProductBeingViewedCustom = (product) => {
    setCartBeingViewed(false);
    setProductBeingViewed(product);
  };

  const setCartBeingViewedCustom = (cartVisibility) => {
    setProductBeingViewed({});
    setCartBeingViewed(cartVisibility);
  };

  useEffect(() => {
    if (productBeingViewed && productBeingViewed.id) {
      window.scrollTo(0, 0); //Scroll to top if product is being viewed
    }
  }, [productBeingViewed]);

  return (
    <>
      <Shopping
        navigation={navigate}
        setProductBeingViewed={setProductBeingViewedCustom}
      />
      <RightPannel
        key={"ViewProduct"}
        componentToPassDown={
          <ViewProduct
            navigation={navigate}
            route={{
              params: {
                product: productBeingViewed,
              },
            }}
            setProductBeingViewed={setProductBeingViewedCustom}
            setCartBeingViewed={setCartBeingViewedCustom}
          />
        }
        open={productBeingViewed && productBeingViewed.id}
        onClose={() => setProductBeingViewed({})}
      />
      <RightPannel
        key={"MyCart"}
        componentToPassDown={
          <MyCart
            navigation={navigate}
            setCartBeingViewed={setCartBeingViewedCustom}
            setProductBeingViewed={setProductBeingViewedCustom}
          />
        }
        open={cartBeingViewed}
        onClose={() => setCartBeingViewed(false)}
      />
    </>
  );
};

export default ShoppingStore;
